import type { AppliedFilter } from "components/Shared/FilterEditor/utils";
import { attachedOutlineButtonProps } from "components/Shared/Forms/RadioButtonGroup";
import RadioButtonOptionsSelect, {
  RadioButtonOptionsSelectProps,
} from "components/Shared/Forms/RadioButtonOptionsSelect";
import { OptionalKeys } from "utils/typescriptUtilis";

export enum ArchivedStatus {
  Active,
  Archived,
  All,
}

const ARCHIVED_STATUS_OPTIONS = [
  ArchivedStatus.Active,
  ArchivedStatus.Archived,
  ArchivedStatus.All,
] as const;

const ARCHIVED_STATUS_OPTION_LABELS: Record<ArchivedStatus, string> = {
  [ArchivedStatus.Active]: "Active",
  [ArchivedStatus.Archived]: "Archived",
  [ArchivedStatus.All]: "All",
};

type Props = OptionalKeys<
  RadioButtonOptionsSelectProps<ArchivedStatus>,
  "options" | "labels"
>;

export default function ArchivedStatusButtonGroup(props: Props) {
  return (
    <RadioButtonOptionsSelect
      options={ARCHIVED_STATUS_OPTIONS}
      labels={ARCHIVED_STATUS_OPTION_LABELS}
      {...attachedOutlineButtonProps}
      {...props}
    />
  );
}

export const IS_ARCHIVED_FILTER_NAME = "isArchived";

export function getValueFromFilters(filters: AppliedFilter[]) {
  const appliedFilter = filters.find(
    (f) => f.filter === IS_ARCHIVED_FILTER_NAME,
  );

  if (!appliedFilter) return ArchivedStatus.All;

  if (typeof appliedFilter.value !== "boolean") return;

  if (appliedFilter.variant === "equalTo") {
    return appliedFilter.value
      ? ArchivedStatus.Archived
      : ArchivedStatus.Active;
  }

  if (appliedFilter.variant === "notEqualTo") {
    return appliedFilter.value
      ? ArchivedStatus.Active
      : ArchivedStatus.Archived;
  }
}

export function makeFiltersHandleChange(
  existingFilters: AppliedFilter[],
  handleFiltersChange: (filters: AppliedFilter[]) => void,
) {
  return (value: ArchivedStatus) => {
    const otherFilters = existingFilters.filter(
      (f) => f.filter !== IS_ARCHIVED_FILTER_NAME,
    );
    handleFiltersChange(
      value === ArchivedStatus.All
        ? otherFilters
        : [
            ...otherFilters,
            {
              filter: IS_ARCHIVED_FILTER_NAME,
              value: value === ArchivedStatus.Archived,
              variant: "equalTo",
            },
          ],
    );
  };
}
